<template>
  <div class="content pr-2">
    <h1 class="has-text-centered">
      About Us
    </h1>
    <hr>
    <div class="is-pulled-left">
      <img
        src="/images/1.png"
        width="200px"
        height="auto"
      >
    </div>
    <p>
      The <strong>Amateur Hold’em League</strong> (AHL) was founded with the players in mind. The founders of AHL (Jerry and Adam) are both Hold’em players and have played in several amateur leagues and professional poker tours around the country. We believe that we have developed a system of play that is by far the most beneficial to any player regardless of their skill level or if they have ever played at all. We offer our members the ability to see statistics and track their progress anytime with our easy-to-use online system.  We play using standard WSOP Texas Hold’em rules, giving our members a chance to learn the game the correct way, from how to bet to what position is. We hold ourselves to the highest standard of customer service and satisfaction, always providing a fun, safe, adult atmosphere that you can feel comfortable with. Our tournament directors are always fun, friendly and helpful and happy to assist you if you have a question or request, so please don’t hesitate to ask. The remaining founder of AHL (Adam) is our CEO and a constant part of day to day operations. He will often play (unannounced) in AHL tournaments to make sure that the experience you have is an enjoyable one every time you play.
    </p>
    <strong>If you’re not satisfied we're not satisfied.</strong>
    <p>
      So if you haven’t played with the AHL, give us a try and if your experience is anything short of great, we want to hear about it.
    </p>
  </div>
</template>

<script>
  export default {
    name: 'AboutUs',
    metaInfo: {
      title: 'AHL Poker :: About Us'
    },
    data () {
      return {}
    },
    computed: {},
    methods: {}
  }
</script>